import React from "react";

import Image from "next/image";

import { Label } from "@/components/ui/label";

export const ErrorLabel = ({ error }: { error?: string }) => {
  if (!error) return null;
  return (
    <div className="text-error-600 mt-2 flex flex-row items-start gap-1">
      <Image src="/images/invalid.svg" height={14} width={14} alt="error" className="-mt-0.25" />
      <Label className="text-body-normal/sm">{error}</Label>
    </div>
  );
};
